<script setup>
import FilterSelect from "@components/activities/FilterSelect.vue";
import IconX from "@components/icons/X.vue";

defineProps(["open", "controls"]);
defineEmits(["close", "reset", "update"]);
</script>

<template>
    <Transition
        enter-active-class="transition-transform duration-200"
        leave-active-class="transition-transform duration-200"
        enter-from-class="translate-y-full"
        leave-to-class="translate-y-full"
    >
        <div
            v-if="open"
            class="filters-sheet bg-marine-800 flex flex-col gap-6 p-6 lg:hidden"
        >
            <div class="flex items-center justify-between">
                <p class="h6 leading-[0.9] font-bold tracking-tight uppercase">
                    Filters
                </p>
                <button
                    class="border-marine-600 shadow-marine-600 flex size-8 items-center justify-center rounded-[4px] border-2 bg-yellow-400 shadow-[0_4px_0]"
                    @click="$emit('close')"
                >
                    <IconX class="text-marine-600 size-3" />
                </button>
            </div>

            <div class="flex flex-1 flex-col gap-6 overflow-y-auto">
                <FilterSelect
                    v-for="control in controls"
                    :key="control.key"
                    :label="control.label"
                    :options="control.options"
                    :model-value="control.value"
                    :disabled="control.disabled"
                    @update:model-value="
                        $emit('update', { key: control.key, value: $event })
                    "
                />
            </div>

            <div class="flex shrink-0 gap-2">
                <button
                    type="button"
                    class="bg-marine-600 relative flex h-12 flex-1 items-center justify-center overflow-hidden px-6"
                    @click="$emit('reset')"
                >
                    <span
                        class="leading-none font-extrabold tracking-wide text-yellow-400 uppercase"
                    >
                        Reset
                    </span>
                    <span
                        class="absolute right-0 bottom-0 size-3 bg-yellow-400"
                        style="clip-path: polygon(100% 0, 100% 100%, 0 100%)"
                    />
                </button>

                <button
                    type="button"
                    class="text-marine-800 flex h-12 flex-1 items-center justify-center bg-yellow-400 px-6"
                    @click="$emit('close')"
                >
                    <span
                        class="leading-none font-extrabold tracking-wide uppercase"
                    >
                        Apply
                    </span>
                </button>
            </div>
        </div>
    </Transition>
</template>

<style scoped>
.filters-sheet {
    grid-column: 1 / -1;
    grid-row: 2 / -1;
    z-index: 100;
}
</style>
